/* Display only. Shopify's existing automatic discount calculates the cart. */
if (!customElements.get('pl8-product-sale-price')) {
  customElements.define('pl8-product-sale-price', class extends HTMLElement {
    connectedCallback() {
      this.regular = this.previousElementSibling;
      if (!this.regular || !this.regular.classList.contains('price')) return;
      this.wasHidden = this.regular.hidden;
      this.update = () => {
        const now = Date.now();
        const active = now >= Date.parse(this.dataset.start) && now < Date.parse(this.dataset.end);
        this.hidden = !active;
        this.regular.hidden = active || this.wasHidden;
        this.regular.classList.toggle('pl8-campaign-native-hidden', active);
      };
      this.update();
      this.timer = setInterval(this.update, 1000);
      document.addEventListener('visibilitychange', this.update);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.update);
      if (this.regular) {
        this.regular.hidden = this.wasHidden;
        this.regular.classList.remove('pl8-campaign-native-hidden');
      }
    }
  });
}

